import MuiTooltip, { type TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

export type TooltipVariant = 'multiline';

export interface TooltipProps extends MuiTooltipProps {
  variant?: TooltipVariant
}

export default function Tooltip(props: TooltipProps) {
  const {
    classes,
    variant,
    ...otherProps
  } = props;
  const tooltipClassName = [
    classes?.tooltip,
    variant === 'multiline' ? 'MuiTooltip-variantMultiline' : undefined,
  ]
    .filter(className => className !== undefined && className !== '')
    .join(' ');

  return <MuiTooltip
    {...otherProps}
    classes={{
      ...classes,
      ...(tooltipClassName !== '' ? { tooltip: tooltipClassName } : {}),
    }}
  />
}
